/* Import Section - Start */

/* React Imports - Start */

import React, { useEffect, useState } from "react";
import { useIsEdited } from "../../Providers/IsEditedProvider";


/* React Imports - End */

/* Plugin Imports - Start */

import { Calendar } from "primereact/calendar";

/* Plugin Imports - End */

/* Import Section - End */

/* Function - Start */

const CalendarElement = (props) => {
  /* State Declaration - Start */

  /* useState - Start */

  /* useState - End */

  /* State Declaration - End */

  /* Methods - Start */

  /* Methods - End */

  /* useEffect - Start */

  /* useEffect - End */

  /* Render View Return - Start */

  const { setIsEdited } = useIsEdited();

  return (
    <>
      <Calendar
        value={props.value}
        defaultValue={props.defaultValue}
        onChange={(e) => {
          setIsEdited(true)
          props.onChange(e)
        }}
        className="custom-calendar"
        register={props.register}
        placeholder= {props.placeholder}
        disabled={props.disabled}
        dateFormat='dd/mm/yy'
      />
    </>
  );

  /* Render View Return - End */
};

/* Function - End */

/* Export default functionName; */

export default CalendarElement;
